import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Panel, Icon, Form, Col, Button, Message, Row, Checkbox } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'

export default function ApproverCommentsWidget({ approverComment }) {
  return (
    <>
      <Panel
        shaded
        header={'สรุปการปรับข้อเสนอโครงการเพื่อรายงานให้กับผู้อนุมัติโครงการทราบ'}
        bordered
        collapsible
        defaultExpanded
      >
        {approverComment?.length > 0 &&
          approverComment.map((item, index) => {
            return index == 0 && <Message key={index} type={'info'} description={`${item.value}`} />
          })}
      </Panel>
      {/* <br /> */}
    </>
  )
}
